define(
    'models/foundation.model',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox
        )
    {
        var _ = Loader._;

        var FoundationModel = Loader.Backbone.Model.extend({

            defaults: {

            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');
            },

            getData: function(callback)
            {
                var _this = this;

                Sandbox.transport.send(Config.transport.channels.foundation, {board_id: this.get('model').get('forum').get('boardId')},
                    function(result){
                        _.isFunction(callback) && callback(result);
                    }, function(err){}
                );
            }

        });

        return {
            initialize: function(model)
            {
                return new FoundationModel({
                    model: model
                })
            }
        }
    }
);

